import { Link2, Facebook, Twitter, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ url, title = "Check this out on Tastebuds" }) {
  const shareUrl = encodeURIComponent(url);
  const shareText = encodeURIComponent(title);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy link");
    }
  };

  const open = (href) => window.open(href, "_blank", "noopener,noreferrer,width=600,height=600");

  const targets = [
    { key: "copy", Icon: Link2, label: "Copy link", onClick: copy },
    { key: "facebook", Icon: Facebook, label: "Share on Facebook", onClick: () => open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`) },
    { key: "x", Icon: Twitter, label: "Share on X", onClick: () => open(`https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`) },
    { key: "whatsapp", Icon: MessageCircle, label: "Share on WhatsApp", onClick: () => open(`https://wa.me/?text=${shareText}%20${shareUrl}`) },
  ];

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      {targets.map(({ key, Icon, label, onClick }) => (
        <button
          key={key}
          onClick={onClick}
          aria-label={label}
          data-testid={`share-${key}`}
          className="w-9 h-9 flex items-center justify-center border border-sand-300 text-sand-700 hover:bg-brand-500 hover:text-sand-50 hover:border-brand-500 transition-colors"
        >
          <Icon size={15} />
        </button>
      ))}
    </div>
  );
}
